// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4578":"f92721c4","5320":"f92721c4"}[chunkId] + ".chunk.css";
};